import { Row, Col } from "v2/components/base/Flex/ui";
import { ReactComponent as LogoIcon } from "assets/icons/logo.svg";
import { Typography } from "@mui/material";
import { useCheckViewPoint, VIEW_POINT_CONFIG } from "hooks/useCheckViewPoint";

const ScrollableEmpty = ({
  title = "Nothing to see here!",
  description = "Please come back later.",
}: {
  title?: string;
  description?: string;
}) => {
  const isMobile = useCheckViewPoint(VIEW_POINT_CONFIG.MOBILE);

  return (
    <Col
      type="cc"
      sx={{
        height: "100%",
        width: "100%",
        padding: isMobile ? "0px 0px 280px" : "20px",
        overflow: "hidden",
      }}>
      <Row
        type="cc"
        sx={{
          width: "100px",
        }}>
        <LogoIcon />
      </Row>
      <Col
        type="sc"
        sx={{
          textAlign: "center",
          color: "#fff",
          gap: "10px",
        }}>
        <Typography variant="mobile-display-xs">{title}</Typography>
        <Typography variant="mobile-body-s">{description}</Typography>
      </Col>
    </Col>
  );
};

export default ScrollableEmpty;
